import { getAdminToken, getToken } from "auth/helpers/authApi";

import { apiClient } from "utils/apiClient";

export enum FeatureConfig {
	/** Dashboard for Admin */
	dashboard = "dashboard",
	/** we use this in FE to show employees list on the sidebar */
	usersFunnel = "usersFunnel",
	/** Employees Management feature for Admin */
	employeesManagement = "employeesManagement",
	/** Buddy Duty feature for Admin */
	buddy = "buddy",
	/** Chatbot using ChatGPT in the game */
	inGameChatGPT = "inGameChatGPT",
	/** Upload document for AI Chatbot */
	knowledgeSources = "knowledgeSources",
	/** Events management */
	events = "events",
	/** Story Builder feature for Admin */
	storyBuilder = "storyBuilder",
	/** List of room templates */
	roomTemplates = "roomTemplates",
	/** Employee Journey Builder for Admin */
	employeeJourneys = "employeeJourneys",
	/** Create room */
	createRoom = "createRooms",
	/** Goal settings */
	goalSettings = "goalSettings",
	/** Credits overview */
	creditsOverview = "creditsOverview",
	/** Questions */
	questionnaire = "questionnaire",
	/** Widget */
	widget = "widget",
	/** Task */
	task = "task",
	/** communications */
	communications = "communications",
	/** Organization Settings */
	orgSettings = "orgSettings",
}

export const getOrgFeatureConfigs = async (): Promise<Record<FeatureConfig, boolean>> => {
	const token = getAdminToken() || getToken();
	const response = await apiClient(`organizations/feature-configs`, { token, method: "GET" });
	return response.data;
};
